"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _isBrowser = _interopRequireDefault(require("../isBrowser"));

var isIE11 = function isIE11() {
  return (0, _isBrowser.default)() && /Trident.*rv[ :]*11\./.test(navigator.userAgent);
};

var _default = isIE11;
exports.default = _default;